<div class="bg-white px-4">
    <header class="mb-10 flex items-center px-8 pt-10">
        <div class="flex items-center">
            <mat-icon class="mr-5 scale-150">schedule</mat-icon>
            <h1 class="text-3xl font-medium">Schedules</h1>
        </div>
    </header>
    @if (schedulesStore.isFulfilled()) {
        <mat-form-field class="w-full">
            <mat-label>Search</mat-label>
            <input
                matInput
                (keyup)="applyFilter($event)" />
        </mat-form-field>
        <button
            mat-flat-button
            color="primary"
            (click)="addSchedule()">
            Add schedule
        </button>
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="name"
            matSortDirection="asc"
            matSortDisableClear>
            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Name
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        {{ element.name }}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="repeat">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Active
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ QuestRepeatType[element.repeat] }}
                </td>
            </ng-container>
            <ng-container matColumnDef="retentionDays">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Retention days
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ element.retentionDays }}
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        [matMenuTriggerFor]="menu">
                        Manage
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            mat-menu-item
                            (click)="editSchedule(element)">
                            Edit schedule
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
    }
</div>
